import type { CollectionCreateSchema } from "typesense/lib/Typesense/Collections";

export const ESSENCE_VERSIONS_SCHEMA: CollectionCreateSchema = {
  name: "essence_versions",
  fields: [
    { name: "essence_id", type: "string", facet: false },
    { name: "version_number", type: "int32", facet: false },
    { name: "is_latest", type: "bool", facet: true },
    {
      name: "source_order",
      type: "int32",
      facet: false,
      optional: true,
      sort: true,
    },
    // Popularity counters, mirrored from Postgres so Popular views can sort
    // inside the same search system as Browse.
    {
      name: "view_count",
      type: "int32",
      facet: false,
      optional: true,
      sort: true,
    },
    {
      name: "favorite_count",
      type: "int32",
      facet: false,
      optional: true,
      sort: true,
    },
    { name: "title", type: "string", optional: false, sort: true },
    { name: "author", type: "string", facet: true, optional: false, sort: true },
    { name: "ai_summary", type: "string", optional: true },
    { name: "description", type: "string", optional: true },
    { name: "effects_text", type: "string", optional: true },
    { name: "sections_text", type: "string", optional: true },
    { name: "keywords", type: "string[]", facet: true, optional: true },
    { name: "categories", type: "string[]", facet: true, optional: true },
    { name: "traits", type: "string[]", facet: true, optional: true },
  ],
  default_sorting_field: "version_number",
};

export const SEARCHABLE_FIELDS = [
  "title",
  "author",
  "ai_summary",
  "description",
  "effects_text",
  "sections_text",
] as const;

export type SearchableField = (typeof SEARCHABLE_FIELDS)[number];

export const FIELD_WEIGHTS: Record<SearchableField, number> = {
  title: 5,
  author: 3,
  ai_summary: 2,
  description: 2,
  effects_text: 1,
  sections_text: 1,
};
